var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutstanding = function SvgOutstanding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8s3.6 8 8 8c1.8 0 3.5-.6 4.9-1.7l.7.7-1 1 6.4 6.4 3.4-3.4-6.4-6.4-1 1-.7-.7C15.4 11.5 16 9.8 16 8m3.6 11-.6.6-3.6-3.6.6-.6zM8 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M9 3H7v1c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2h2v1H5v2h2v1h2v-1c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H7V6h4V4H9z"
  })));
};
export default SvgOutstanding;